var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 69.5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 37309"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 17439",
    fill: "#fff",
    stroke: "#185edf"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 69.5,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 68.5,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8518",
    fill: "none",
    stroke: "#c3cbd7",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M8.5 10h53"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8520",
    fill: "none",
    stroke: "#c3cbd7",
    strokeLinecap: "round",
    strokeWidth: 4,
    d: "M8.5 40h31"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 8519",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8.5 47h34"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": 123,
    transform: "translate(8 28.5)",
    fill: "#dc1e1e",
    fontSize: 16,
    fontFamily: "RobotoSlab-Black, Roboto Slab",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "123")), /*#__PURE__*/React.createElement("text", {
    "data-name": 321,
    transform: "translate(8 59.5)",
    fill: "#1c9f00",
    fontSize: 16,
    fontFamily: "RobotoSlab-Black, Roboto Slab",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "321")), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 24",
    d: "m48.5 51.5 4.5 8h-9Z",
    fill: "#1c9f00"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 25",
    d: "m48.5 28.5-4.5-8h9Z",
    fill: "#dc1e1e"
  }), /*#__PURE__*/React.createElement("text", {
    "data-name": "%",
    transform: "translate(55 59.5)",
    fill: "#1c9f00",
    fontSize: 13,
    fontFamily: "RobotoSlab-Black, Roboto Slab",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%")), /*#__PURE__*/React.createElement("text", {
    "data-name": "%",
    transform: "translate(55 28.5)",
    fill: "#dc1e1e",
    fontSize: 13,
    fontFamily: "RobotoSlab-Black, Roboto Slab",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "%")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberChart);
export default __webpack_public_path__ + "static/media/numberChart.da29fafbc9c93813962ef5a3a9600f2c.svg";
export { ForwardRef as ReactComponent };